<template>
  <div style="padding: 56px">
    <div>
      <v-card
        :style="{
          borderBottom: '3px solid #272727',
          borderLeft: '1px solid #272727',
          borderTop: '1px solid #272727',
          borderRight: '3px solid #272727',
          borderRadius: '10px',
        }"
        flat
        max-width="600"
      >
        <v-sheet
          class="d-flex justify-center align-center py-2"
          color="accent"
          style="font-size: 10pt; font-weight: 600"
        >
          Pricing & offer
        </v-sheet>
        <v-divider class="primary"></v-divider>
        <div class="pa-6">
          <div class="px-6 py-2">
            <p style="text-align: center">
              Hi James, as one of the next ten companies on the waiting list I
              am happy to say we have a slot available for you. You're eligable
              for the startup program, and I can give you the first three months
              for €1.
            </p>
          </div>

          <div class="price-cards">
            <v-card color="primary" class="pa-8">
              <p style="font-size: 14pt; font-weight: 600" class="mb-2">Paid</p>
              <p style="font-size: 30pt; font-weight: 600" class="mb-0">€89</p>
              <p style="font-size: 8pt">per workspace license</p>
              <p style="font-size: 11pt">
                Everything you need to manage your socials.
              </p>
              <div class="d-flex align-center mb-2" style="gap: 10px">
                <v-icon color="white" size="20">mdi-check</v-icon>
                <p class="mb-0" style="font-size: 11pt">Unlimited user seats</p>
              </div>
              <div class="d-flex align-center mb-2" style="gap: 10px">
                <v-icon color="white" size="20">mdi-check</v-icon>
                <p class="mb-0" style="font-size: 11pt">
                  Unlimited social accounts
                </p>
              </div>
              <div class="d-flex align-center mb-2" style="gap: 10px">
                <v-icon color="white" size="20">mdi-check</v-icon>
                <p class="mb-0" style="font-size: 11pt">
                  100.000 Stix AI tokens (~200 posts)
                </p>
              </div>
              <div class="d-flex align-center mb-2" style="gap: 10px">
                <v-icon color="white" size="20">mdi-check</v-icon>
                <p class="mb-0" style="font-size: 11pt">Expert onboarding</p>
              </div>
              <v-btn color="smoke darken-4" elevation="0" class="mt-4" block
                >Create my account</v-btn
              >
              <p style="font-size: 8pt; text-align: center; margin-top: 5px">
                <i>Incl. 60 days money back guarantee</i>
              </p>
            </v-card>

            <v-card color="primary " class="pa-8">
              <p style="font-size: 14pt; font-weight: 600" class="mb-2">
                Startup
                <v-chip small color="secondary" class="ml-2"
                  ><v-icon size="x-small" class="mr-1" color="primary"
                    >mdi-check-circle</v-icon
                  >
                  Eligable</v-chip
                >
              </p>
              <p style="font-size: 30pt; font-weight: 600" class="mb-0">€29</p>
              <p style="font-size: 8pt">per workspace license</p>
              <p style="font-size: 11pt">
                Apply for almost
                <span class="font-weight-bold smoke--text">70% discount</span>
                on the Paid plan in our
                <span class="button--text font-weight-bold"
                  >Startup Program</span
                >. You are eligible if your company is less than 10 years old.
                Simple.
              </p>
              <v-btn block color="button" elevation="0"
                >Create my account</v-btn
              >
              <p style="font-size: 8pt; text-align: center; margin-top: 5px">
                <i> Incl. 60 days money back guarantee</i>
              </p>
            </v-card>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.price-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
  p {
    color: #f0f0f0;
  }
}
</style>
